export const icons = {
    lock: ['M7 11V8a5 5 0 0 1 10 0v3', 'M5 11h14v9H5z'],
    loud: ['M4 9h4l5-4v14l-5-4H4z', 'M16 9a4 4 0 0 1 0 6'],
    profile: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4 20a8 8 0 0 1 16 0'],
    battery: ['M3 8h16v8H3z', 'M21 11v2'],
    system: ['M12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z', 'M8.5 15a5 5 0 0 1 0-6M15.5 9a5 5 0 0 1 0 6', 'M12 13v8'],
    direct: ['M4 12h16', 'M8 8l-4 4 4 4', 'M16 8l4 4-4 4'],
    arrowUp: ['M12 19V5', 'M6 11l6-6 6 6'],
    arrowDown: ['M12 5v14', 'M6 13l6 6 6-6'],
    arrowLeft: ['M19 12H5', 'M11 6l-6 6 6 6'],
    arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
    call: ['M4 5c0 8 7 15 15 15l2-3-4-3-2 2a14 14 0 0 1-5-5l2-2-3-4z'],
    power: ['M12 4v8', 'M7.5 6.5a7 7 0 1 0 9 0']
}
